import React from 'react'
import {isEmpty} from "lodash"
function isNull(a, type) {
  //type null:text,1:number
  return !a ? (!type ? "-" : "0") : a;
}
function arrObjhandler(a, b) {
  if(isEmpty(a)) {
    // console.log('reach empty')
    return "-"
  } else {
    console.log('data is true',a ,b)
      // let emp_data = a.data.data.employee_total_jobs
      let emp_data = a
      let res = !emp_data ? {} : emp_data[0];
      return res[b];
    }
}
const TeamTotalJobCard = ({ teamTotalJob }) => {
  // console.log('empTotalJob', empTotalJob)
    return(
      <div className="card-stat mb-4" style={{ display: "flex" }}>
                  {/* total jobs */}
                  <div className="col-4 text-center">
                    <h3>
                      {isNull(
                      arrObjhandler(
                        teamTotalJob,
                        "all_job"
                      ),
                      1
                    )}
                      {/* 729 */}
                    </h3>
                    <span>Total Jobs</span>
                  </div>
                  {/* Today jobs */}
                  <div className="col-4 text-center">
                    <h3>
                      {isNull(
                      arrObjhandler(
                        teamTotalJob,
                        "today_job"
                      ),
                      1
                    )}
                      {/* 20 */}
                    </h3>
                    <span>Today</span>
                  </div>
                  {/* Month jobs */}
                  <div className="col-4 text-center">
                    <h3>
                      {isNull(
                      arrObjhandler(
                        teamTotalJob,
                        "month_job"
                      ),
                      1
                    )}
                      {/* 50 */}
                    </h3>
                    <span>Month</span>
                  </div>
                  {/* <div className="col-2 text-center">
                  <h3>
                    {isNull(
                      arrObjhandler(
                        this.state.emp_details.employee_total_jobs,
                        "finish_job"
                      ),
                      1
                    )}
                  </h3>
                  <span>Finish</span>
                </div> */}
                </div>
    );
}

export default TeamTotalJobCard